import { NaniumObject, Type } from "nanium/objects";

export class AnabinCountry extends NaniumObject<AnabinCountry> {
	@Type(String) id: string;
	@Type(String) short: string;
	@Type(String) official: string;
	@Type(String) name: string;
	@Type(String) code: string;
}
